export default __webpack_public_path__ + "static/media/MK.726d8682.webp";